import React, { useState, useEffect } from "react";

// Components
import Sidebar from "../../components/Sidebar";
import Main from "./Creditor/Main";
import Form from "./Creditor/Form";

// Utils
import { getData, getAlert, getDataWithComp } from "../../../utils/SamuiUtils";
import { InitialDataCreditor } from "../../../model/InitialData/InitialDataCreditor";
import Navbar from "../../components/Modal/Navbar";

const Creditor = () => {
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  const [dataAPtype, setDataAPtype] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [formData, setFormData] = useState(InitialDataCreditor());

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      setMode("S");
      fetchRealtime(); // เรียกใช้งาน fetchRealtime เพื่อโหลดข้อมูลเมื่อ component โหลดครั้งแรก
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      const masterList = await getDataWithComp("View_Set_AP", "Order By AP_Code");
      const dataAPtype = await getData("Tb_Set_APType", "1=1");
      console.debug("dataAPtype", dataAPtype);
      if (masterList && masterList.length > 0) {
        masterList.sort((a, b) => a.AP_Code.localeCompare(b.AP_Code));
        setDataMasterList(masterList);
      }
      if (dataAPtype && dataAPtype.length > 0) {
        setDataAPtype(dataAPtype);
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const onPageInsert = () => {
    setMode("I");
  };

  const onRowSelected = (item) => {
    console.debug("item", item);
    setMode("U");
    setFormData({
      ap_id: item.AP_Id,
      comp_id: window.localStorage.getItem("company"),
      ap_code: item.AP_Code,
      ap_name: item.AP_Name,
      ap_type: item.APType_Name,
      ap_shortname: item.AP_ShortName,
      ap_taxno: item.AP_TaxNo,
      ap_add1: item.AP_Add1,
      ap_add2: item.AP_Add2,
      ap_add3: item.AP_Add3,
      ap_province: item.AP_Province,
      ap_zipcode: item.AP_Zipcode,
      ap_contact: item.AP_Contact,
      ap_contact2: item.AP_Contact2,
      ap_tel: item.AP_Tel,
      ap_tel2: item.AP_Tel2,
      ap_group: item.AP_Group,
      ap_refsalecode: item.AP_RefSaleCode,
      ap_area: item.AP_Area,
      ap_status: item.AP_Status,
      ap_credit: item.AP_Credit,
      ap_vat: item.AP_Vat,
      ap_discount: item.AP_Discount,
      ap_branch: item.AP_Branch,
      ap_bt_name: item.AP_BT_Name,
      ap_email: item.AP_Email,
      ap_email2: item.AP_Email2,
      ap_fb_email: "",
      ap_fb_telephone: "",
    });
    setSelectedData(item);
  };

  return (
    <div className="Creditor">
      <div className="wrapper">
        <Navbar />
        <div className="main-panel">
          <div className="container">
            <div className="page-inner">
              {mode === "S" ? (
                <Main
                  masterList={dataMasterList}
                  name={"ข้อมูลเจ้าหนี้"}
                  onPageInsert={() => onPageInsert()}
                  onRowSelected={(item) => onRowSelected(item)}
                />
              ) : (
                <Form
                  callInitialize={initialize}
                  mode={mode}
                  name={"ข้อมูลเจ้าหนี้"}
                  formData={formData}
                  setFormData={setFormData}
                  selectedData={selectedData}
                  dataAPtype={dataAPtype}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Creditor;
